import React from 'react';
import { List, Datagrid, TextField, EditButton, DeleteButton, FunctionField } from 'react-admin';

const WordleEventsList = (props) => (
  <List title="Wordle Events" bulkActionButtons={false} sort={{ field: 'id', order: 'DESC' }} {...props}>
    <Datagrid rowClick="edit">
      <TextField label="ID" source="id" />
      <TextField label="Date" source="date" sortable={false} />
      <FunctionField
        label="Word"
        render={(record) => (Array.isArray(record?.letters) ? record.letters.join('') : '')}
      />
      <EditButton />
      <DeleteButton undoable={false} />
    </Datagrid>
  </List>
);

export default WordleEventsList;
